import { makeStyles } from 'tss-react/mui';
import { GRAY_ALTERNATIVE } from "src/global/theme/colors";

export const styles = makeStyles()(() => {
  return {
    screenContainer: {
      width: '100%',
      position: 'fixed',
      zIndex: '1000',
      backgroundColor: GRAY_ALTERNATIVE,
    },
    modoIcon: {
      display: 'flex',
      alignItems: 'center'
    },
    outlet: {
      height: "100%",
    },
    contentLayout: {
      padding: "15% 6%",
      backgroundColor: GRAY_ALTERNATIVE,
    },
  };
});
